export function checkValidURL(url: string) {
  const urlPattern = /^(https?|http):\/\/[^\s/$.?#].\S*$/i;
  return urlPattern.test(url);
}
